import React, { useState, useEffect, useContext } from 'react'; 
import NewContractButton from '../components/NewContractButton';
import ContractCard from '../components/ContractCard';
import { useAuth } from '../utils/AuthContext/AuthContext';
import { Link } from 'react-router-dom'; 
import UpcomingDates from '../components/UpcomingDates';
import ChecklistGlobal from '../components/ChecklistGlobal';
import { useMediaQuery } from 'react-responsive';
import StepContainer from '../components/NextSteps/StepContainer'; 
// import EnhancedNextSteps from '../components/agenticNextSteps/EnhancedNextSteps';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';
import EmptyState  from '../components/EmptyState';
import TaskList from '../components/NextSteps2.0/TaskList';

import config from '../utils/config'

function HomePage({ formData }) {
    const [contracts, setContracts] = useState([]); 
    const [loading, setLoading] = useState(true); 
    const [showAllContracts, setShowAllContracts] = useState(false);
    const { token, user, formSaved, isAdmin } = useAuth(); // Use user and token from context
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    // Retrieve and parse the user object from local storage
    const userString = localStorage.getItem('user');
    const userObject = userString ? JSON.parse(userString) : null;
    const [refreshContracts, setRefreshContracts] = useState(false); // New flag for refreshing
    const email = userObject?.email;
    const userId = userObject?.id || userObject?._id;

    // Sort contracts based on the specified criteria
    const sortedContracts = contracts.sort((a, b) => {
        // Ensure packetDetails and status exist before comparing
        const aStatus = a.packetDetails?.status;
        const bStatus = b.packetDetails?.status;
        const aUpdatedAt = new Date(a.packetDetails?.updatedAt);
        const bUpdatedAt = new Date(b.packetDetails?.updatedAt);

        // First, sort by status
        if (aStatus === 'completed' && bStatus !== 'completed') {
            return -1;
        }
        if (aStatus !== 'completed' && bStatus === 'completed') {
            return 1;
        }
        // If both have the same status, sort by updatedAt date
        return bUpdatedAt - aUpdatedAt;
    });

    // console.log("formSaved Value", formSaved);

    useEffect(() => {
        if (formSaved) {
        async function fetchData() {
            try {
                const response = await fetch(`${config.apiBaseUrl}/formdata/user`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setContracts(data);
            } catch (error) {
                console.error("Error fetching contracts:", error);
            } finally {
                setLoading(false); 
            }
        }      
        fetchData();
        }
    }, [token, formSaved, refreshContracts]);  

    const completedContracts = contracts.filter(contract => contract.packetDetails?.status === 'completed');

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <LoadingSpinner />
            </div>
        );
    }

    if (contracts.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-shi-eggshell pb-20">
                <EmptyState />
            </div>
        );
    }

return (
    <>
    {completedContracts.length === 0 ? (
        isMobile ?
            <div className='flex flex-col justify-start w-full'>
                <div className='w-full flex justify-start pl-2'>
                    <NewContractButton width={120} height={70} textSize={14} iconHeight={15} iconWidth={15} email={email}/>
                </div> 
                <div className='flex justify-center'>
                    <div className="flex flex-col w-full">
                        <div className='flex flex-col w-full md:px-0'>                    
                            <div className='flex gap-3 overflow-x-auto w-full h-56 mt-3 pl-2 justify-start'>
                                {(showAllContracts ? sortedContracts : sortedContracts.slice(0, 6)).map(contract => (
                                    <ContractCard key={contract._id} contractData={contract} />
                                ))}
                            </div> 
                            {contracts.length > 6 && (
                                <div className="flex justify-end w-full">
                                    <button 
                                        className='text-shi-green hover:underline mt-1 mr-4'
                                        onClick={() => setShowAllContracts(!showAllContracts)}
                                    >
                                        {showAllContracts ? <span className='text-[14px]'>See Less</span> : <span className='text-[14px]'>See All</span>}
                                    </button>
                                </div>
                            )}
                            <div className='flex flex-wrap w-full justify-center gap-4 mt-[5px] mb-3 md:mb-10 px-2'>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        :
            <div className='flex flex-col justify-center items-center w-full px-10 h-full bg-shi-eggshell'>
                <div className='flex'>
                    <div className="flex w-screen pr-16 pl-8">
                        <div className='h-full mr-2 mt-14'>
                        </div>
                        <div className='flex flex-col w-full'>  
                            <div className='w-full inline-flex justify-end gap-5 align-middle'>
                                {contracts.length > 3 && (
                                    <div className="flex justify-end">
                                        <button 
                                            className=' text-shi-green hover:underline border-spacing-2 border-[1px] text-[14px] border-shi-green rounded-md px-2 py-1'
                                            onClick={() => setShowAllContracts(!showAllContracts)}
                                        >
                                            {showAllContracts ? 'See Less' : 'See All'}
                                        </button>
                                    </div>
                                )}
                                <NewContractButton width={120} textSize={14} iconHeight={15} iconWidth={15} email={email}/>
                            </div>                  
                            <div className='flex flex-wrap gap-3 mt-[20px]'>
                                {(showAllContracts ? contracts : contracts.slice(0, 3)).map(contract => (
                                    <ContractCard key={contract._id} contractData={contract} />
                                ))}
                            </div>
                            <div className='flex flex-wrap justify-start mt-[20px]'>
                                {contracts.map(contract => (
                                    <UpcomingDates key={contract._id} formData={contract} userId={userId} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    ) : (
        <TaskList contracts={completedContracts} userId={userId} onTerminated={() => setRefreshContracts(prev => !prev)}/>
    )}
</>
);
}

export default HomePage;